import { createClient } from '@base44/sdk';
import { appParams } from '@/lib/app-params';

const { appId, token, functionsVersion, appBaseUrl } = appParams;

export const base44 = createClient({
  appId,
  token,
  functionsVersion,
  serverUrl: '',
  appBaseUrl,
  // The SDK's own event beacon fired during start-up and sat on the critical request
  // chain, delaying the first paint. Every number the app actually reports on comes
  // from Google Analytics and the server-side visit records instead.
  analytics: { enabled: false }
});